import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { IGroupType } from "./interface/group-type.interface";

export const GroupTypes: IGroupType[] = [BackendResourceEnum.CONTRACT, BackendResourceEnum.INVOICE];
